// extracted by mini-css-extract-plugin
export default {"main":"BannerImageAd_main__0ClIp"};